import { Dispatch } from 'react';
import ACTION_TYPES from './actionTypes';

export interface FetchAction {
  type: ACTION_TYPES.AXIOS_ACTION;
  payload: FetchActionPayload;
}

export interface FetchActionPayload {
  url: string;
  method?: 'get' | 'post' | 'put' | 'delete';
  data?: any;
  initActionType: ACTION_TYPES;
  successActionType: ACTION_TYPES;
  failedActionType: ACTION_TYPES;
}

function fetchData<T>(dispatch: Dispatch<any>, actionCreator: (args?: T) => FetchAction, actionCreatorParams?: T) {
  const action: FetchAction = actionCreator(actionCreatorParams);
  const {
    data,
    method = 'get',
    url,
    initActionType,
    successActionType,
    failedActionType,
  } = action.payload;

  // dispatch an action indicating a pending API call
  dispatch({
    type: initActionType,
  });

  function errorCallback(error: any) {
    dispatch({
      type: failedActionType,
      data,
      error,
    });
  }

  fetch(url, {
    body: data,
    method,
  }).then(function (response) {
    response.json().then(function (responseJson) {
      dispatch({
        type: successActionType,
        data: responseJson,
      });
    }, errorCallback);
  }, errorCallback);
}

export function createFetchAction(payload: FetchActionPayload): FetchAction {
  return {
    type: ACTION_TYPES.AXIOS_ACTION,
    payload,
  };
}

export default fetchData;